import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { LANGUAGES, LanguageService } from '../core/language';

@Component({
  selector: 'app-languages',
  templateUrl: './languages.html',
})
export class LanguagesPage {
  protected readonly lang = inject(LanguageService);
  protected readonly choices = LANGUAGES;
  private readonly router = inject(Router);

  protected pick(code: string): void {
    this.lang.choose(code);
    void this.router.navigateByUrl('/');
  }
}
